import React from "react";
import ChevronRight from "../assets/icons/chevron-right.svg";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../context/Global";

function Header() {
  const params = useParams();
  const { data, activePhase, activeTask } = useGlobalState();

  return (
    <header className="bg-gray-100">
      <div className="bg-gray-100 xl:container px-8 py-5">
        <div className="flex items-center mb-2 text-sm">
          {data.paths.path.map((p, i) => (
            <div className="flex items-center" key={"p" + i}>
              <a href={p.$["xlink:href"]} className="text-primary-dark ">
                {p._}
              </a>
              <ChevronRight width="10px" height="10px" className="mx-1" />
            </div>
          ))}

          <div className="flex items-center">
            <Link to={`/`} className="text-primary-dark ">
              Alliance Cloud Checklist Home
            </Link>
            {!!Object.keys(params).length && <ChevronRight width="10px" height="10px" className="mx-1" />}
          </div>

          {!!Object.keys(params).length && activePhase && (
            <div className="flex items-center">
              <a className=" ">{activePhase.title}</a>
              <ChevronRight width="10px" height="10px" className="mx-1" />
            </div>
          )}

          {!!Object.keys(params).length && activeTask && (
            <div className="flex items-center">
              <a className=" ">{activeTask.title}</a>
            </div>
          )}
        </div>
        <div className="flex justify-between text-gray-500 mt-4">
          <div>
            <div className="text-4xl font-bold ">{data?.title}</div>
            {data?.description}
          </div>
          <div className="flex items-center"></div>
        </div>
      </div>
    </header>
  );
}

export default Header;
